"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight } from "lucide-react";
import Image from "next/image";
import { TransitionLink } from "@/components/transition-link";
import BgCardsDots from "~/public/assets/services/bg-cards-dots.png";
import type { ServiceItem } from "./services-content";
export type ServiceMobileCardProps = {
  service: ServiceItem;
  defaultLinkLabel: string;
  defaultLinkHref: string;
};
export function ServiceMobileCard(t0) {
  const $ = _c(17);
  const {
    service,
    defaultLinkLabel,
    defaultLinkHref
  } = t0;
  let t1;
  if ($[0] !== service.title) {
    t1 = service.title.replace("\n", " ");
    $[0] = service.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${defaultLinkLabel}: ${t1}`;
  const t3 = service.linkHref ?? defaultLinkHref;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src={BgCardsDots} alt="" aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-full w-full object-cover opacity-[0.16]" sizes="80vw" />;
    t5 = <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_6%,rgba(255,92,0,0.22),rgba(255,92,0,0.08)_24%,rgba(0,0,0,0)_58%)]" />;
    t6 = <ArrowUpRight className="absolute top-4 right-4 text-primary-300" size={22} strokeWidth={1.8} />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== service.icon) {
    t7 = <Image src={service.icon} alt="" aria-hidden="true" className="relative z-10 h-32 w-auto object-contain" height={150} width={150} />;
    $[5] = service.icon;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== service.title) {
    t8 = <h3 className="relative z-10 mt-8 whitespace-pre-line text-xl font-medium leading-[120%] text-primary-300">{service.title}</h3>;
    $[7] = service.title;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== service.description) {
    t9 = <p className="relative z-10 mt-7 text-[12px] leading-[150%] text-white/48">{service.description}</p>;
    $[9] = service.description;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = <TransitionLink aria-label={t2} className="relative flex min-h-90 flex-col items-center overflow-hidden rounded-lg border border-primary-300/15 bg-black px-7 py-9 text-center" href={t3}>{t4}{t5}{t6}{t7}{t8}{t9}</TransitionLink>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}